function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 256,
  cy: 256,
  fill: "#f0f0f0",
  r: 256
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m256 512c141.384 0 256-114.616 256-256 0-31.314-5.632-61.311-15.923-89.043h-480.154c-10.29 27.732-15.923 57.729-15.923 89.043 0 141.384 114.616 256 256 256z",
  fill: "#0052b4"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m256 512c110.071 0 203.906-69.472 240.077-166.957h-480.154c36.171 97.485 130.006 166.957 240.077 166.957z",
  fill: "#d80027"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m66.198 144.696v127.706c0 72.644 94.901 94.903 94.901 94.903s94.9-22.259 94.9-94.903v-127.706z",
  fill: "#f0f0f0"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m88.459 144.696v127.706c0 8.528 1.894 16.582 5.646 24.133h133.987c3.752-7.55 5.646-15.605 5.646-24.133v-127.706z",
  fill: "#d80027"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "m205.62 233.739h-33.39v-22.261h22.261v-22.261h-22.261v-22.26h-22.261v22.26h-22.26v22.261h22.26v22.261h-33.392v22.261h33.392v22.261h22.261v-22.261h33.39z",
  fill: "#f0f0f0"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "m124.471 327.61c14.345 9.015 29.083 14.249 36.628 16.577 7.545-2.327 22.283-7.562 36.628-16.577 14.466-9.092 24.607-19.49 30.365-31.075-6.351-4.493-14.1-7.143-22.471-7.143-3.048 0-6.009.361-8.856 1.024-6.033-13.708-19.728-23.285-35.665-23.285s-29.633 9.577-35.665 23.285c-2.847-.663-5.809-1.024-8.856-1.024-8.371 0-16.12 2.65-22.471 7.143 5.755 11.584 15.896 21.982 30.363 31.075z",
  fill: "#0052b4"
});

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var _ref21 =
/*#__PURE__*/
React.createElement("g", null);

var _ref22 =
/*#__PURE__*/
React.createElement("g", null);

var _ref23 =
/*#__PURE__*/
React.createElement("g", null);

var Svg218Slovakia = function Svg218Slovakia(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg218Slovakia, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/218-slovakia.e8420452.svg";
export { ForwardRef as ReactComponent };